import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";


import Unauthorized from "pages/unAuthorized";
import RequireAuth from "components/requireAuth";
import {canProspect, canSeeStats} from "helper/roles";
import HomePage from "pages/home/HomePage";
import TasksPage from "pages/tasks/TasksPage";
import ProspectionPage from "pages/prospection/ProspectionPage";
import CompaniesPage from "pages/companies/CompaniesPage";
import PlanningPage from "pages/planning/PlanningPage";
import StatsPage from "pages/stats/StatsPage";
import CompanyPage from "pages/companies/CompanyPage";
import ContactPage from "pages/companies/ContactPage";
import GroupPage from "pages/companies/GroupPage";
import Documents from "pages/pages/Documents";
import Contract
    from "pages/content/documents/contracts/contract";
import Sign from "pages/content/documents/contracts/sign";
import Nosign
    from "pages/content/documents/contracts/nosign";
import Payslip
    from "pages/content/documents/payslip/payslip";
import {Help} from "assets/icons";
import Profil from "pages/pages/Profil";
import Experience
    from "pages/content/savoirfaire/experience";
import Langues from "pages/content/savoirfaire/langues";
import Tools from "pages/content/savoirfaire/tools";
import Identity
    from "pages/content/justificatifs/identity";
import Formations
    from "pages/content/justificatifs/formations";
import Licences
    from "pages/content/justificatifs/licences";
import Myhours from "pages/content/disponibilites/myhours";
import Availabilities
    from "pages/content/disponibilites/availabilities";
import Mission from "pages/pages/Mission";
import Progress from "pages/content/mission/progress";
import Completed from "pages/content/mission/completed";
import Comingsoon from "pages/content/mission/comingsoon";
import SearchMission from "pages/pages/SearchMission";
import Missionfiche
    from "pages/pages/mission/missionfiche";
import LayoutTw from 'components/layout'
import Layout from "pages/pages/layout";
import IdentityValidation from "../pages/pages/IdentityValidation";
import TimeSheetsBeSTT from "../pages/pages/timeSheetsBeSTT";
import TimeSheet from "../pages/timeSheet/timeSheet";
import CheckedContent from "../pages/timeSheet/content/checked.content";
import ToBeCheckedContent from "../pages/timeSheet/content/toBeChecked.content";
import LitigationContent from "../pages/timeSheet/content/litigation.content";
import FicheHour from "../pages/content/documents/hours/ficheHour";
import MissionPeriod from "../pages/pages/mission/missionPeriod";
import Vivier from 'pages/pages/vivier/vivier.js';
import FicheVivier from 'pages/pages/vivier/fiche.vivier.js';
import ListAllVivier from 'pages/pages/vivier/list.vivier.js';
import PdfView from "pages/pages/pdfView";
import VivierRatingTempWorker from "../pages/pages/vivier/vivier-rating-temp-worker";
import Qualification from "../pages/pages/qualification/qualification";
import ToBeCompletedContent from "../pages/timeSheet/content/toBeCompleted.content";
import PayslipManagement from "../pages/payslipManagement/payslipManagement";
import LegacyPayslipManagementRedirect from "./LegacyPayslipManagementRedirect";
import PayslipContent from "../pages/payslipManagement/content/payslip.content";
import InvoiceContent from "../pages/payslipManagement/content/invoice.content";
import RemindersContent from "../pages/payslipManagement/content/reminders.content";
import HistoryContent from "../pages/payslipManagement/content/history.content";
import StatsContent from "../pages/payslipManagement/content/stats.content";
import JobbizGame from "../pages/pages/JobbizGame";
import Intercom from "../pages/pages/Intercom";
import AdminConsole from "../pages/pages/AdminConsole";
import AdminProfil from "../pages/pages/AdminProfil";
import AdminGoals from "../pages/pages/AdminGoals";
import AdminClientSizes from "../pages/pages/AdminClientSizes";
import AdminAgencyGoals from "../pages/pages/AdminAgencyGoals";

const TempWorkerRoutes = () => {
    const ROLES = {
        'admin': '500',
        'steeve': '525',
        'alternant': '515',
        'commercial': '510',
        'recruiter': '520',
    }

    return (
        <>
            <Routes>
                <Route path='/' element={<Layout/>}>
                    <Route path={'admin'} element={<LayoutTw/>}/>
                    <Route element={<RequireAuth allowedRoles={[ROLES.admin, ROLES.steeve, ROLES.alternant, ROLES.commercial, ROLES.recruiter]}/>}>
                        <Route path='dashboard' element={<HomePage/>}/>
                        <Route path='tasks' element={<TasksPage/>}/>
                        <Route path='planning' element={<PlanningPage/>}/>
                        <Route path='jobbiz-game' element={<JobbizGame/>}/>
                        <Route path='intercom' element={<Intercom/>}/>
                        <Route path='identity_validation' element={<IdentityValidation/>}/>
                        <Route path='admin-profil' element={<AdminProfil/>}/>
                        <Route path='vivier' element={<Vivier/>}/>
                        <Route path='ficheVivier/:id' element={<FicheVivier/>}/>
                        <Route path='listAllVivier' element={<ListAllVivier/>}/>
                        <Route path='company' element={<CompaniesPage/>}></Route>
                        <Route path='company/group/:id' element={<GroupPage/>}/>
                        <Route path='company/group/:groupId/contacts/:contactId' element={<ContactPage/>}/>
                        <Route path='company/:id' element={<CompanyPage/>}/>
                        <Route path='company/:companyId/contacts/:contactId' element={<ContactPage/>}/>
                        <Route path='missions' element={<MissionPeriod/>}></Route>
                        <Route path='documents' element={<Documents/>}>
                            <Route path='contracts' element={<Contract/>}>
                                <Route path={'sign'} element={<Sign/>}/>
                                <Route path={'nosign'} element={<Nosign/>}/>
                            </Route>
                            <Route path='payslip' element={<Payslip/>}/>
                        </Route>
                        <Route path='help' element={<Help/>}/>
                        <Route path='profil' element={<Profil/>}>
                            <Route path='savoir_faire'>
                                <Route path='experiences'
                                       element={<Experience/>}/>
                                <Route path='language'
                                       element={<Langues/>}/>
                                <Route path='tools'
                                       element={<Tools/>}/>
                            </Route>
                            <Route path='justificatifs'>
                                <Route path='identity'
                                       element={<Identity/>}/>
                                <Route path='degree'
                                       element={<Formations/>}/>
                                <Route path='licence'
                                       element={<Licences/>}/>
                            </Route>
                            <Route path='disponibilites'>
                                <Route path='myhours'
                                       element={<Myhours/>}/>
                                <Route path='availabilities'
                                       element={<Availabilities/>}/>
                            </Route>
                        </Route>
                        <Route path='mission' element={<Mission/>}>
                            <Route path={'in_progress'}
                                   element={<Progress/>}/>
                            <Route path={'completed'}
                                   element={<Completed/>}/>
                            <Route path={'coming_soon'}
                                   element={<Comingsoon/>}/>
                        </Route>
                        <Route path='searchMission'
                               element={<SearchMission/>}/>
                        <Route path='ficheMission/:id'
                               element={<Missionfiche/>}/>
                    </Route>
                    {/* Timesheets, payroll, billing, qualifications and reviews: out of the
                        Commercial's menu (JBWEB-1415) and the recruiter's (JBWEB-1416), so closed
                        to 510 and 520 even by direct address. */}
                    <Route element={<RequireAuth allowedRoles={[ROLES.admin, ROLES.steeve, ROLES.alternant]}/>}>
                        <Route path={'timeSheet'} element={<TimeSheet/>}>
                            <Route path={'checked'} element={<CheckedContent/>}/>
                            <Route path={'toBeChecked'} element={<ToBeCheckedContent/>}/>
                            <Route path={'litigation'} element={<LitigationContent/>}/>
                            <Route path={'toBeCompleted'} element={<ToBeCompletedContent/>}/>
                            <Route path={'ficheHour/:id'} element={<FicheHour/>}/>
                        </Route>
                        <Route path={'payroll'} element={<PayslipManagement section={'payroll'}/>}>
                            <Route index element={<Navigate to="payslips" replace />} />
                            <Route path={'payslips'} element={<PayslipContent/>}/>
                            <Route path={'history'} element={<HistoryContent/>}/>
                            <Route path={'stats'} element={<StatsContent/>}/>
                        </Route>
                        <Route path={'billing'} element={<PayslipManagement section={'billing'}/>}>
                            <Route index element={<Navigate to="invoices" replace />} />
                            <Route path={'invoices'} element={<InvoiceContent/>}/>
                            <Route path={'reminders'} element={<RemindersContent/>}/>
                        </Route>
                        <Route path={'payslipManagement/*'} element={<LegacyPayslipManagementRedirect/>}/>
                        <Route path='qualification' element={<Qualification/>}/>
                        <Route path={'vivier-rating-temp-worker/rating-untreated'} element={<VivierRatingTempWorker/>}/>
                        <Route path={'vivier-rating-temp-worker/rating-treated'} element={<VivierRatingTempWorker/>}/>
                    </Route>
                    {/* Prospecting follows canProspect, like the sidebar link. */}
                    <Route element={<RequireAuth allow={(role) => canProspect(Number(role))}/>}>
                        <Route path='prospection' element={<ProspectionPage/>}/>
                    </Route>
                    {/* The statistics: the Commercial's, and theirs for the agency manager. */}
                    <Route element={<RequireAuth allow={(role) => canSeeStats(Number(role))}/>}>
                        <Route path='statistics' element={<StatsPage/>}/>
                    </Route>
                    <Route element={<RequireAuth allowedRoles={[ROLES.admin]}/>}>
                        <Route path='admin-console' element={<AdminConsole/>}/>
                        <Route path='admin-console/objectifs' element={<AdminGoals/>}/>
                        <Route path='admin-console/taille-clients' element={<AdminClientSizes/>}/>
                        <Route path='admin-console/objectifs-agence' element={<AdminAgencyGoals/>}/>
                    </Route>
                    {/*<Route path={'*'} element={<Unauthorized/>}/>*/}
                    <Route path='pdfView' element={<PdfView/>}/>
                    <Route path={""} element={<Navigate to="/dashboard"/>} />
                    <Route path={"*"} element={<Navigate to="/dashboard"/>} />
                    <Route path={'/timeSheetsBeSTT'} element={<TimeSheetsBeSTT/>}/>
                </Route>
            </Routes>
        </>
    )
        ;
};

export default TempWorkerRoutes;